<div class="p-6 space-y-6" id="page-catalogos">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Catálogos</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Administración de catálogos del sistema</p>
    </div>
    <button type="button" class="btn btn-primary gap-2 w-full sm:w-auto">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nuevo Catálogo
    </button>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800 flex flex-col sm:flex-row gap-3">
      <label class="input w-full sm:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar catálogo..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Tipo: Todos</option>
        <option>Ubicación</option>
        <option>Trámites</option>
        <option>Documentos</option>
      </select>
    </div>

    <div class="p-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_OI1MjH8uh"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Tipos de Trámite</h4>
      <p class="text-xs text-gray-400 mb-3">24 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-green-100 dark:bg-green-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_Y15nZsOps"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Estados y Municipios</h4>
      <p class="text-xs text-gray-400 mb-3">2,468 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_RNpDA91Kg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Dependencias Gubernamentales</h4>
      <p class="text-xs text-gray-400 mb-3">87 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_xWwHt761s"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Estatus de Proyectos</h4>
      <p class="text-xs text-gray-400 mb-3">8 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-yellow-100 dark:bg-yellow-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_k7CboK9kW"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Etiquetas y Categorías</h4>
      <p class="text-xs text-gray-400 mb-3">32 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    <div class="bg-base-100 dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 p-5 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition cursor-pointer">
      <div class="w-10 h-10 rounded-xl bg-red-100 dark:bg-red-900/30 items-center justify-center mb-4 flex">
        <svg class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_Ny8HCKxzK"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
      </div>
      <h4 class="font-bold text-gray-800 mb-1 dark:text-white">Tipos de Documentos</h4>
      <p class="text-xs text-gray-400 mb-3">45 registros activos</p>
      <div class="flex gap-2">
        <button type="button" class="btn btn-ghost flex-1">Ver</button>
        <button type="button" class="btn btn-outline btn-primary flex-1">Editar</button>
      </div>
    </div>
    </div>
  </div>
</div>

